<template>
  <div class="custom-container" v-loading.fullscreen.lock="loyaltyItem.isLoading">
    <el-row>
      <el-row type="flex" align="center" class="my-4" justify="space-between">
        <el-col :span="5">
          <div class="category-title">Create Loyalty Item</div>
        </el-col>
        <el-col :span="4">
          <el-row type="flex" justify="end">
            <el-button size="small" @click="$router.go(-1)">Kembali</el-button>
            <el-button size="small" type="primary" @click="save">Simpan</el-button>
          </el-row>
        </el-col>
      </el-row>

      <el-col :span="24">
        <el-form
          label-width="120px"
          label-position="left"
          ref="bodyLoyaltyItem"
          :model="bodyLoyaltyItem"
        >
          <Form :bodyLoyaltyItem="bodyLoyaltyItem"></Form>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Form from "./Form";
import { mapActions, mapState } from "vuex";
export default {
  components: {
    Form
  },
  data: () => ({
    bodyLoyaltyItem: {
      name: "",
      price: "",
      categoryKey: "",
      imageURL: "",
      description: "",
    },
    valid: true,
  }),
  computed: {
    ...mapState({
      loyaltyItem: state => state.loyaltyItem.loyaltyItem
    })
  },
  methods: {
    ...mapActions({
      createLoyaltyItem: "loyaltyItem/CreateLoyaltyItem"
    }),
    save() {
      this.$refs.bodyLoyaltyItem.validate(valid => {
        if (valid) {
          this.createLoyaltyItem(this.bodyLoyaltyItem);
          this.snackbar = true;
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style>
</style>
